import React, { FC, memo } from 'react'
import { Link } from 'react-router-dom'
import { FrontUrls } from 'Src/constants/FrontUrls'
import { ArticleModel, KindTypeModel } from 'Pages/knowledge'
import { i18n } from 'LibNeo'

interface ComponentProps {
	article?: ArticleModel
	preview?: boolean
}

export const BreadCrumbsArticleViewComponent: FC<ComponentProps> = memo(
	({ article, preview }): JSX.Element => {
		const titleView = `${
			preview ? `Предпросмотр ${article.kind === KindTypeModel.VIDEO ? 'видео' : 'статьи'}` : ''
		} 
		${article?.name ? `"${article.name}"` : ''}`
		const projectLink = preview
			? FrontUrls.knowledge.project_edit.replace(':id', String(article.project.id))
			: FrontUrls.knowledge.project_view.replace(':slugProject', article.project.slug)

		return (
			<div className="knowledge__breadcrumbs">
				<Link to={FrontUrls.knowledge.index}>{i18n('nav.knowledge')}</Link>
				{' / '}
				<>
					{(article?.project?.id || article?.project?.slug) && (
						<>
							<Link to={projectLink}>{article.project.name}</Link>
							{' / '}
						</>
					)}
					<span>{titleView}</span>
				</>
			</div>
		)
	}
)
